import { Client, Storage, Databases, ID, Permission, Role } from 'appwrite';

// Primary Appwrite client
const client = new Client()
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);

export const storage = new Storage(client);

// Tutor platform client (second Appwrite instance)
const tutorPlatformClient = new Client()
    .setEndpoint('https://sgp.cloud.appwrite.io/v1')
    .setProject(process.env.REACT_APP_TUTOR_PLATFORM_PROJECT_ID);

export const tutorPlatformDb = new Databases(tutorPlatformClient);
export const tutorPlatformStorage = new Storage(tutorPlatformClient);

export { ID, Permission, Role };
export default client;